import { RemoveSupplierModal } from "./RemoveSupplierModal";

export default RemoveSupplierModal;
